import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 500,
      md: 900,
      lg: 1200,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      light: "#fff",
      main: "#0C80F3",
      dark: "#2196F3",
      contrastText: "#fff",
      success: "#31c274",
      heading: "#29264A",
    },
    primaryButton: {
      main: "rgba(105, 33, 196, .1)",
      contrastText: "#00a66e",
    },
    primarylight: {
      main: "#00a66e",
      contrastText: "#fff",
    },
    cancelButton: {
      main: "rgba(109, 125, 139, 0.3)",
      contrastText: "#6D7D8B",
    },
    disabledButton: {
      main: "rgba(109, 125, 139, 0.2)",
      contrastText: "rgba(109, 125, 139, 0.4)",
    },
    secondary: {
      main: "#566875",
    },
    secondaryButton: {
      main: "#FFD9C8",
      contrastText: "#ff6019",
    },
    warningButton: {
      main: "rgba(255, 25, 25, 0.2)",
      contrastText: "#ff3636",
    },
    success: {
      main: "#3DC583",
    },
    successChip: {
      main: "rgba(12, 200, 87, 0.2)",
      contrastText: "#31c274",
    },
    successWhiteButton: {
      main: "#31c274",
      contrastText: "#fff",
    },
    error: {
      main: "#ff3636",
    },
    disabled: {
      main: "#A4A8AC",
      light: "#6D7D8B",
      hot: "#545B7D",
      black: "#000",
      boxHeading: "#566875",
      customs: "rgba(0, 0, 0, 0.87)",
    },
    disSelect: {
      contrastText: "#6D7D8B",
      main: "#F4F7FB",
    },
    inactive: {
      main: "#F7F8FB",
      contrastText: "#A6BCBF",
    },
  },
  typography: {
    fontSize: 14,
    button: {
      fontSize: "1.4rem",
    },
    h1: {
      fontSize: "4.8rem",
      fontWeight: "bold",
      lineHeight: "4.8rem",
    },
    h2: {
      fontSize: "3.6rem",
      fontWeight: "bold",
      lineHeight: "4.8rem",
    },
    h3: {
      fontSize: "3.2rem",
      fontWeight: 500,
      lineHeight: "4.4rem",
    },
    h4: {
      fontWeight: "500",
      fontSize: "1.6rem",
      lineHeight: "1.9rem",
    },
    h5: {
      fontWeight: "500",
      fontSize: "2.4rem",
    },
    h6: {
      fontWeight: "500",
      fontSize: "1.4rem",
      lineHeight: "1.9rem",
    },
    h7: {
      fontWeight: "500",
      fontSize: "1.3rem",
      lineHeight: "1.5rem",
    },
    body1: {
      fontSize: "1.6rem",
    },
    body2: {
      fontSize: "1.4rem",
    },
    boxHeading: {
      fontWeight: "500",
      fontSize: "1.6rem",
      lineHeight: "2.8rem",
    },
    listSecondary: {
      fontWeight: "500",
      fontSize: "1.2rem",
      lineHeight: "1.5rem",
    },
    tableHeading: {
      fontWeight: "500",
      fontSize: "1.1rem",
      lineHeight: "1.3rem",
    },
    tableSemiHeading: {
      fontWeight: "400",
      fontSize: "1.2rem",
      lineHeight: "1.4rem",
    },
    listText: {
      fontSize: "2rem",
      lineHeight: "4rem",
      fontWeight: "400",
    },
    subtitle1: {
      fontSize: "2.4rem",
      lineHeight: "2.8rem",
      fontWeight: "500",
    },
    mainLabel: {
      fontWeight: "500",
      fontSize: "1.4rem",
      lineHeight: "1.9rem",
    },
    labelSmall: {
      fontSize: "1.3rem",
      fontWeight: "400",
      lineHeight: "1.8rem",
    },
    helperText: {
      fontSize: ".75rem",
      fontWeight: "400",
      lineHeight: "1.66",
      letterSpacing: "0.03333em",
    },
    caption: {
      fontSize: "1.2rem",
    },
  },

  components: {
    MuiButton: {
      variants: [
        {
          props: { size: "small" },
          style: { fontSize: "1.4rem" },
        },
        {
          props: { size: "large" },
          style: { fontSize: "1.5rem" },
        },
      ],
    },
    MuiLoadingButton: {
      variants: [
        {
          props: { size: "small" },
          style: { fontSize: "1.3rem" },
        },
      ],
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "2.4rem",
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          fontSize: "1.4rem",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: "1.3rem",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          fontSize: "1.4rem",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "1rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          "&:-webkitAutofill": {
            WebkitBoxShadow: "0 0 0 30px #fff inset",
            // WebkitTextFillColor: "var(--color-disabled-hot)",
          },
        },
      },
    },
  },
});

export default theme;
